import React from 'react';
import { useDispatch } from 'react-redux';
import withTokenInterceptor from '../../../hoc/withTokenInterceptor/withTokenInterceptor';

import { initializePageAction } from '../../../store/theme.actions';
import AlterarPercentuaisProcesso from './AlterarPercentuaisProcesso';

function AlterarPercentuaisProcessoPage() {
  const dispatch = useDispatch();

  dispatch(initializePageAction('Alterar Percentuais Recebimento e Pagto Direto'));
  return (
    <AlterarPercentuaisProcesso />
  );
}

export default withTokenInterceptor(AlterarPercentuaisProcessoPage);
